export const COLUMNS = [
  'Text',
  'Location',
  'Frequency',
  'Idle Time at Location',
  'Time of Day',
  'Status',
];
export const FREQUENCY = 'frequency';
export const FREQUENCY_UNIT = 'frequencyUnit';
export const IDLE_TIME = 'idleTime';
export const LOCATION = 'locationTypeId';
export const NOTIFICATION_TEXT = 'text';
export const TIME_OF_DAY = 'timeOfDay';
export const STATUS = 'isActive';



// WEBPACK FOOTER //
// ./src/modules/NotificationManagement/constants.js